import { AxiosInstance } from "axios";
import { Method, Resource } from "../Resource";

export type AutofillRequest = {
  data: string;
};

export class Autofill extends Resource<{}> {
  constructor(axiosInstance: AxiosInstance) {
    super("autofill", axiosInstance);
  }

  public async performAutofill(
    performAutofillRequest: AutofillRequest
  ): Promise<object> {
    return this.request({
      method: Method.POST,
      body: performAutofillRequest
    });
  }
}
